import {checkIfHexBlockedByEnemyUnit} from "./checkIfHexBlockedByEnemyUnit";
import {checkIfAdjacentToWorkingWarehouse} from './supply/checkIfAdjacentToWorkingWarehouse';
import {
  FARM_SUPPLY_BLOCKED_COUNT,
  FARM_SUPPLY_STANDARD_COUNT,
  FARM_SUPPLY_WITH_WAREHOUSE_COUNT
} from "../../constants/supply";
import {TOKENS} from "../../constants/tokens";

export const calcFarmRemainingSupply = (farmHexKey, selectedFarmsForConversion, hexes, specialBuildings, players, units, citiesCache, currentPlayer, pendingSupply, buildingsDamage) => {
  if (checkIfHexBlockedByEnemyUnit(farmHexKey, TOKENS.FARM, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage)) {
    return FARM_SUPPLY_BLOCKED_COUNT;
  }

  const isAdjacentToWarehouse = checkIfAdjacentToWorkingWarehouse(farmHexKey, specialBuildings, units, players, citiesCache, currentPlayer, hexes, buildingsDamage);
  const maxSupply = isAdjacentToWarehouse ? FARM_SUPPLY_WITH_WAREHOUSE_COUNT : FARM_SUPPLY_STANDARD_COUNT;

  // Считаем сколько уже отдано снабжения с этой фермы. Обычные записи снабжения - 1 запись
  // = 1 единица; batched-записи доп. снабжения великанов (farmHexKeys) могут ссылаться на одну
  // и ту же ферму несколько раз (ферма смежно складу дает 2 единицы за ход) - считаем ВХОЖДЕНИЯ
  // fармы внутри массива, а не количество подходящих записей pendingSupply
  const allocatedSupplyCount = pendingSupply.reduce((count, s) => {
    if (s.farmHexKey === farmHexKey) {
      return count + 1;
    }
    if (s.farmHexKeys) {
      return count + s.farmHexKeys.filter(hexKey => hexKey === farmHexKey).length;
    }
    return count;
  }, 0);

  const selectedForConversion = selectedFarmsForConversion.filter(hexKey => hexKey === farmHexKey).length;

  return maxSupply - allocatedSupplyCount - selectedForConversion;
}